export default "/images/1db912a36db5e06b6371eb13d2830d1a.avif";